import { Components, Theme } from '@mui/material'

export const MuiTabs: Components<Omit<Theme, 'components'>>['MuiTabs'] = {
  defaultProps: {
    variant: 'scrollable',
    scrollButtons: false,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      minHeight: 48,
      maxHeight: 48,
      flex: '1 1 0%',
      minWidth: 0,
      maxWidth: '100%',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.text.primary,
        height: 1,
      },
      '& .MuiTabs-flexContainer': {
        gap: theme.spacing(3),
        height: 48,
        minWidth: 0,
      },
      '& .MuiTabs-scroller': {
        position: 'absolute',
        inset: 0,
        overflow: 'auto !important',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollBehavior: 'smooth',
        // If it's full-width, the tab bar doesn't naturally overflow, so don't apply the fade/mask.
        ...(ownerState.variant !== 'fullWidth'
          ? {
              maskImage:
                'linear-gradient(to right, black calc(100% - 60px), rgba(0,0,0,0.3) calc(100% - 40px), transparent 100%)',
              WebkitMaskImage:
                'linear-gradient(to right, black calc(100% - 60px), rgba(0,0,0,0.3) calc(100% - 40px), transparent 100%)',
            }
          : {}),
      },
    }),
  },
}
